export { default as withOnlyJiraAdmin } from './with-only-jira-admin';
